import React, { PropsWithChildren, useCallback, useState } from "react";

import { Stack } from "@mui/material";

import {
  AdvisorId,
  ClientId,
  PortfolioPlanId,
} from "@fartherfinance/frontend/api/Types";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import { DropdownMenuOption } from "@src/sharedComponents/CustomDropdownBase/MenuOptionsWithCheckIfSelected/MenuOptionsWithCheckIfSelected";
import ModalWithClearButton from "@src/sharedComponents/Modal/ModalWithClearButton";
import Text from "@src/sharedComponents/Typography/Text";

import DropdownPortfolioPlanOptions from "./DropownPortfolioPlanOptions";

import styles from "./ModelPickerModal.module.css";

interface Props {
  closeModal: () => void;
  onSubmit: (portfolioPlanId: PortfolioPlanId) => void;
  isOpen: boolean;
  clientId: ClientId;
  advisorId?: AdvisorId;
}

const ModelPickerModal: React.FC<PropsWithChildren<Props>> = ({
  closeModal,
  onSubmit,
  isOpen,
  clientId,
  advisorId,
}) => {
  const [selectedTaxType, setSelectedTaxType] = useState<
    DropdownMenuOption<PortfolioPlanId> | undefined
  >(undefined);

  const onPick = useCallback(() => {
    if (selectedTaxType?.id === undefined) {
      return;
    }

    onSubmit(selectedTaxType.id);
    closeModal();
  }, [closeModal, onSubmit, selectedTaxType?.id]);

  return (
    <ModalWithClearButton closeModal={closeModal} isOpen={isOpen}>
      <Text className={styles.title} variant="title2">
        Pick a Model Portfolio
      </Text>
      <DropdownPortfolioPlanOptions
        advisorId={advisorId}
        clientId={clientId}
        selectedTaxType={selectedTaxType}
        onSelectedTaxType={setSelectedTaxType}
      />
      <Stack
        spacing={2}
        direction={"row"}
        marginTop={"16px"}
        justifyContent={"flex-end"}
      >
        <Button
          text="Cancel"
          buttonType="primary"
          variant="text"
          disabled={false}
          onClick={closeModal}
        />

        <Button
          text="Continue"
          buttonType="primary"
          variant="contained"
          disabled={selectedTaxType?.id === undefined}
          onClick={onPick}
        />
      </Stack>
    </ModalWithClearButton>
  );
};

export default ModelPickerModal;
